<template>
<div>
  <div class="intro">
    <h1>加葱40日挑戰</h1>
  </div>
  <div class="survey">
    <hr align="center">
    <p>剩餘日數: {{ update['hp'] }}</p>
    <div class="updateAb">
    <button @click="updateHP(1)">增加 1 日</button>
    <button @click="updateHP(-1)">減少 1 日</button>
    <button @click="openConfirm()">New Game</button><br>
    </div>
    <div class="updateAb"><p>「重視工作」稱號: {{ update['v1'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('v1')">更新開關</button></div>
    <div class="updateAb"><p>「重視與異性關係」稱號: {{ update['v2'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('v2')">更新開關</button></div>
    <div class="updateAb"><p>「好奇心」稱號: {{ update['v3'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('v3')">更新開關</button></div>
    <div class="updateAb"><p>「重視團隊精神」稱號: {{ update['v4'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('v4')">更新開關</button></div>
    <div class="updateAb"><p>「願了解別人」稱號: {{ update['v5'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('v5')">更新開關</button></div>
    <div class="updateAb"><p>對新事物持開放態度: {{ update['a1'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('a1')">更新開關</button></div>
    <div class="updateAb"><p>抵抗逆境態度: {{ update['a2'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('a2')">更新開關</button></div>
    <div class="updateAb"><p>熱愛表演態度: {{ update['a3'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('k1')">更新開關</button></div>
    <div class="updateAb"><p>管理社交媒體知識: {{ update['k1'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('k2')">更新開關</button></div>
    <div class="updateAb"><p>編劇知識: {{ update['k2'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('k3')">更新開關</button></div>
    <div class="updateAb"><p>整理個人履歷技能: {{ update['s1'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('s1')">更新開關</button></div>
    <div class="updateAb"><p>思考分析技能: {{ update['s2'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('s2')">更新開關</button></div>
    <div class="updateAb"><p>駕駛技能: {{ update['s3'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('s3')">更新開關</button></div>
    <div class="updateAb"><p>魔術教學能力技能: {{ update['s4'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('s4')">更新開關</button></div>
    <div class="updateAb"><p>攝影及後期製作技能: {{ update['s5'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('s5')">更新開關</button></div>
    <div class="updateAb"><p>照顧病患技能: {{ update['s6'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('s6')">更新開關</button></div>
    <div class="updateAb"><p>健身技能: {{ update['s7'] ? '開啟' : '關閉' }} </p><button @click="updateAbility('s7')">更新開關</button></div>
  </div>
</div>
</template>

<script>
import { db } from '../main';

export default {
  name: 'SituationUpdate',
  data() {
    return {
      update: {
        hp: 40,
        v1: false,
        v2: false,
        v3: false,
        v4: false,
        v5: false,
        a1: false,
        a2: false,
        a3: false,
        k1: false,
        k2: false,
        s1: false,
        s2: false,
        s3: false,
        s4: false,
        s5: false,
        s6: false,
        s7: false
      },
      original: {
        hp: 40,
        v1: false,
        v2: false,
        v3: false,
        v4: false,
        v5: false,
        a1: false,
        a2: false,
        a3: false,
        k1: false,
        k2: false,
        s1: false,
        s2: false,
        s3: false,
        s4: false,
        s5: false,
        s6: false,
        s7: false
      },
    }
  },
  methods: {
    updateHP: function(amount) {
      var instance = this;
      this.$vs.loading({type:'radius'});

      this.update['hp'] += amount;
      var rtDocRef = db.collection("situation").doc("vGXm16O3cvhXrxKs5bVI").set(this.update)
        .then(() => instance.$vs.loading.close()
      );
      
    },
    updateAbility: function(id) {
      var instance = this;
      this.$vs.loading({type:'radius'});

      this.update[id] = !this.update[id];
      var rtDocRef = db.collection("situation").doc("vGXm16O3cvhXrxKs5bVI").set(this.update)
        .then(() => instance.$vs.loading.close()
      );
    },
    openConfirm: function() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `確認開始新遊戲?`,
        text: '之前所有的遊戲資料將會永久刪除, 繼續?',
        accept: this.addNew
      })
    },
    addNew: function() {
      var instance = this;
      this.$vs.loading({type:'radius'});

      this.update = Object.assign({}, this.original);
      var rtDocRef = db.collection("situation").doc("vGXm16O3cvhXrxKs5bVI").set(this.original)
        .then(() => instance.$vs.loading.close()
      );
    }
  },
  mounted() {
    var instance = this;
    var rtDocRef = db.collection("situation").doc("vGXm16O3cvhXrxKs5bVI").get().then((snapshot) => {
      let data = snapshot.data();
      if (data != undefined) {
        this.update = data;
      }
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.intro {
  padding: 10px;
}

.intro p {
  padding: 3px;
}

button {
  margin: 0 5px;
}

.updateAb {
  display: flex;
  justify-content: center;
  margin: 10px;
}

hr {
  width: 30%;
  text-align: center; 
  margin: 8px auto;
}

@media screen and (min-width: 1024px) {
  .question {
    padding: 5px 30%;
  }
  hr {
    width: 50%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SituationUpdate.vue